module.exports = {
      id: "a15774544781543a58d33e26fd437f01equipment-fireplace.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#a15774544781543a58d33e26fd437f01equipment-fireplace.svg",
      toString: function () {
        return this.url;
      }
    }